import axios from 'axios';

export const getTokenGodMode = async () => {
  try {
    const response = await axios.get(
      'https://tokenonco.kdash.com.br/api/token'
    );
    console.log('Token recebido:', response.data.access_token);
    return response.data.access_token;
  } catch (error) {
    console.error(
      'Erro ao buscar token do backend:',
      error.response?.data || error.message
    );
    throw error;
  }
};

// getTokenGodMode();
